/* Padlys ROI-Rechner — Berechnungslogik.
   Statisches Asset (kein Liquid), initialisiert jede Instanz auf der Seite
   über das Attribut data-roi-root und liest ihre Startwerte aus data-*. */
(function () {
  // Echte Preise aus der Staffelpreis-Tabelle (templates/product.json,
  // Section "price_table"): 7 Mengen-Stufen × 3 Größen. Der Mauspad-Preis
  // wird NICHT mehr manuell eingestellt, sondern automatisch aus der
  // gewählten Mitarbeiterzahl (= Bestellmenge) und der gewählten Größe
  // berechnet — der Kunde muss nicht selbst in der Tabelle nachschlagen.
  // Bei Preisänderungen an der Staffelpreis-Tabelle muss diese Matrix von
  // Hand nachgezogen werden.
  var TIERS = [
    { max: 9, label: '1–9 Stück' },
    { max: 24, label: '10–24 Stück' },
    { max: 49, label: '25–49 Stück' },
    { max: 99, label: '50–99 Stück' },
    { max: 199, label: '100–199 Stück' },
    { max: 499, label: '200–499 Stück' },
    { max: Infinity, label: '500+ Stück' }
  ];
  var SIZES = ['30×25 cm', '80×30 cm', '90×40 cm'];
  var PRICE_MATRIX = [
    [12.95, 24.95, 29.95],
    [11.65, 22.45, 26.95],
    [11.00, 21.20, 25.45],
    [10.35, 19.95, 23.95],
    [9.70, 18.70, 22.45],
    [9.05, 17.45, 20.95],
    [8.45, 16.25, 19.45]
  ];

  // Mitarbeiter-Regler: der native <input type="range"> läuft intern linear
  // von 0–EMPLOYEES_SLIDER_STEPS und wird über eine Potenzkurve auf den
  // eigentlichen Mitarbeiterbereich (1–500) abgebildet. Exponent > 1 sorgt
  // dafür, dass die erste Hälfte des Reglerwegs nur die unteren ~100
  // Mitarbeiter abdeckt (feine Abstufung für kleine Teams) und der Rest des
  // Wegs schnell auf 500 hochzählt (grobe Abstufung, wo Präzision egal ist).
  var EMPLOYEES_MIN = 1;
  var EMPLOYEES_MAX = 500;
  var EMPLOYEES_CURVE = 2.3;
  var EMPLOYEES_SLIDER_STEPS = 1000;

  function employeesFromSlider(pos) {
    var t = clamp01(pos / EMPLOYEES_SLIDER_STEPS);
    return Math.round(EMPLOYEES_MIN + (EMPLOYEES_MAX - EMPLOYEES_MIN) * Math.pow(t, EMPLOYEES_CURVE));
  }

  function sliderFromEmployees(val) {
    var t = clamp01((val - EMPLOYEES_MIN) / (EMPLOYEES_MAX - EMPLOYEES_MIN));
    return Math.round(Math.pow(t, 1 / EMPLOYEES_CURVE) * EMPLOYEES_SLIDER_STEPS);
  }

  function clamp01(n) {
    if (isNaN(n)) return 0;
    return Math.max(0, Math.min(1, n));
  }

  function tierIndexFor(employees) {
    for (var i = 0; i < TIERS.length; i++) {
      if (employees <= TIERS[i].max) return i;
    }
    return TIERS.length - 1;
  }

  function initRoot(root) {
    if (root.dataset.roiInit === '1') return;
    root.dataset.roiInit = '1';

    var hoursMap = {
      konservativ: parseFloat(root.dataset.hoursKons) || 52,
      moderat: parseFloat(root.dataset.hoursMod) || 64,
      intensiv: parseFloat(root.dataset.hoursInt) || 134
    };

    var state = {
      scenario: root.dataset.scenario || 'moderat',
      employees: parseInt(root.dataset.employees, 10) || 5,
      hourlyCost: parseInt(root.dataset.hourly, 10) || 35,
      size: parseInt(root.dataset.size, 10) || 1,
      softwareIncluded: root.dataset.softwareIncluded !== 'false'
    };
    // Software-Preis ist fest (nur eine Preisstufe im Angebot, siehe
    // Section-Einstellung "software_price") — nur AN/AUS wählbar, kein Regler.
    var softwarePriceFixed = parseFloat(root.dataset.software) || 29.95;

    var bounds = {
      employees: [EMPLOYEES_MIN, EMPLOYEES_MAX],
      hourlyCost: [15, 90]
    };

    var scenarioButtons = Array.prototype.slice.call(
      root.querySelectorAll('[data-roi-scenario]')
    );
    var sizeButtons = Array.prototype.slice.call(
      root.querySelectorAll('[data-roi-size]')
    );
    var softwareToggle = root.querySelector('[data-roi-input="softwareIncluded"]');

    function nf(n, d) {
      d = d || 0;
      return n.toLocaleString('de-DE', {
        minimumFractionDigits: d,
        maximumFractionDigits: d
      });
    }

    function set(key, val) {
      var el = root.querySelector('[data-roi="' + key + '"]');
      if (el) el.textContent = val;
    }

    function clamp(v, min, max) {
      if (isNaN(v)) v = min;
      return Math.max(min, Math.min(max, v));
    }

    function update() {
      var tierIndex = tierIndexFor(state.employees);
      var tier = TIERS[tierIndex];
      var padPrice = PRICE_MATRIX[tierIndex][state.size];
      var softwarePrice = state.softwareIncluded ? softwarePriceFixed : 0;

      var hpy = hoursMap[state.scenario];
      var totalHours = state.employees * hpy;
      var moneySaved = totalHours * state.hourlyCost;
      var investment = state.employees * (padPrice + softwarePrice);
      var roi = investment > 0 ? moneySaved / investment : 0;
      var workDays = totalHours / 8;
      var dailySaving = (hpy / 230) * state.hourlyCost * state.employees;
      var amortDays = dailySaving > 0 ? investment / dailySaving : 0;
      var progress = Math.min(100, (amortDays / 30) * 100);

      set('employeesVal', state.employees);
      set('hourlyVal', nf(state.hourlyCost) + ' €');
      set('padVal', nf(padPrice, 2) + ' €');
      set('padHint', tier.label + ', ' + SIZES[state.size]);

      set('money', nf(Math.round(moneySaved)) + ' €');
      set('employees2', state.employees);
      set('employeesWord', state.employees === 1 ? 'Mitarbeiter' : 'Mitarbeitern');
      set('totalHours', nf(Math.round(totalHours)) + ' Std.');
      set('workDays', nf(Math.round(workDays)));
      set('investment', nf(Math.round(investment)) + ' €');
      set('roi', nf(roi, 1) + '×');
      set('amort', nf(Math.round(amortDays)) + ' Tage');

      var bar = root.querySelector('[data-roi="progress"]');
      if (bar) bar.style.width = progress.toFixed(1) + '%';

      scenarioButtons.forEach(function (b) {
        b.classList.toggle('is-active', b.getAttribute('data-roi-scenario') === state.scenario);
      });
      sizeButtons.forEach(function (b) {
        b.classList.toggle('is-active', parseInt(b.getAttribute('data-roi-size'), 10) === state.size);
      });
    }

    Object.keys(bounds).forEach(function (key) {
      var input = root.querySelector('[data-roi-input="' + key + '"]');
      if (!input) return;

      if (key === 'employees') {
        input.value = sliderFromEmployees(state.employees);
        input.addEventListener('input', function (e) {
          state.employees = clamp(
            employeesFromSlider(parseInt(e.target.value, 10)),
            bounds.employees[0],
            bounds.employees[1]
          );
          update();
        });
        return;
      }

      input.value = state[key];
      input.addEventListener('input', function (e) {
        state[key] = clamp(parseInt(e.target.value, 10), bounds[key][0], bounds[key][1]);
        update();
      });
    });

    scenarioButtons.forEach(function (b) {
      b.addEventListener('click', function () {
        state.scenario = b.getAttribute('data-roi-scenario');
        update();
      });
    });

    sizeButtons.forEach(function (b) {
      b.addEventListener('click', function () {
        state.size = parseInt(b.getAttribute('data-roi-size'), 10);
        update();
      });
    });

    if (softwareToggle) {
      softwareToggle.checked = state.softwareIncluded;
      softwareToggle.addEventListener('change', function (e) {
        state.softwareIncluded = e.target.checked;
        update();
      });
    }

    update();
  }

  function initAll() {
    Array.prototype.slice
      .call(document.querySelectorAll('[data-roi-root]'))
      .forEach(initRoot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Beim Bearbeiten im Shopify-Theme-Editor neu initialisieren.
  document.addEventListener('shopify:section:load', initAll);
})();
